var _title, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgServices = function SvgServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Services")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.65,3 C10.92,3 11.1,3.18 11.1,3.45 L11.1,3.45 L11.1,5.25 C11.1,5.52 10.92,5.7 10.65,5.7 L10.65,5.7 L10.2,5.7 L10.2,10.56 C12.27,11.28 13.8,13.26 13.8,15.6 C13.8,18.57 11.37,21 8.4,21 C5.43,21 3,18.57 3,15.6 C3,13.26 4.53,11.28 6.6,10.56 L6.6,10.56 L6.6,5.7 L6.15,5.7 C5.88,5.7 5.7,5.52 5.7,5.25 L5.7,5.25 L5.7,3.45 C5.7,3.18 5.88,3 6.15,3 L6.15,3 Z M20.55,3 C20.82,3 21,3.18 21,3.45 L21,3.45 L21,5.25 C21,5.52 20.82,5.7 20.55,5.7 L20.55,5.7 L20.1,5.7 L20.1,17.85 C20.1,19.11 19.11,20.1 17.85,20.1 C16.59,20.1 15.6,19.11 15.6,17.85 L15.6,17.85 L15.6,5.7 L15.15,5.7 C14.88,5.7 14.7,5.52 14.7,5.25 L14.7,5.25 L14.7,3.45 C14.7,3.18 14.88,3 15.15,3 L15.15,3 Z M12,15.6 L4.8,15.6 C4.8,17.58 6.42,19.2 8.4,19.2 C10.38,19.2 12,17.58 12,15.6 L12,15.6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "white",
    xlinkHref: "#path-1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/services.010b27f3.svg";
export { ForwardRef as ReactComponent };